export const inhabitedProperty = str => {
  if (str && isNaN(str)) {
    return str.toUpperCase() === 'SIM';
  }
};
